import { render } from "./RevisionInfo.vue?vue&type=template&id=4c7850cd&scoped=true"
import script from "./RevisionInfo.vue?vue&type=script&lang=js"
export * from "./RevisionInfo.vue?vue&type=script&lang=js"

import "./RevisionInfo.vue?vue&type=style&index=0&id=4c7850cd&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c7850cd"]])

export default __exports__